import { action } from '@ember/object';
import SettingsGroupsBaseController from '../base';
import GroupModel from 'scaleflow/models/group';

export default class SettingsGroupsGroupEditController extends SettingsGroupsBaseController {
  declare model: GroupModel;
  @action
  cancel() {
    // Rollback changes to avoid persisting unsaved changes
    this.model.rollbackAttributes();
    this.goToListPage();
  }
}
